export enum AvailableLanguageTypes {
  ENGLISH = 'en',
  THAI = 'th'
}

export type Money = {
  amount: number;
  currency: string;
};

export type IconsProps = {
  width?: number;
  height?: number;
  color?: string;
};
